/*@flow*/
import type { Element } from 'react';
import React, { useContext } from 'react';
import BuilderContext from '../Context';
import commands from '../commands';

export default (props: { className?: string }): Element<'a'> => {
  const ctx = useContext(BuilderContext);

  return (
    <a
      className={props.className}
      tabIndex={0}
      onClick={() => {
        commands(ctx).startIntegration();
      }}
    >
      <i className="fa fa-cog" />
    </a>
  );
};
